module.exports = __webpack_public_path__ + "static/media/instagram.e56b8381.png";